import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { useUserCount } from './hooks/useUserCount';

export function TakingActionBody(): JSX.Element {
	const {
		data: { totalUserCount, totalUserCountLocalized },
	} = useUserCount();
	return (
		<div className="flex flex-col items-center justify-center gap-4">
			<Text as="h2" variant="heading" className="text-center">
				<TranslatePlural
					value="fe.pages.impact.map_section.title_with_num"
					count={totalUserCount}
					replacements={{ num: totalUserCountLocalized }}
				/>
			</Text>
			<Text size="large" as="p" className="max-w-2xl text-center">
				<Translate value="fe.pages.impact.map_section.description" />
			</Text>
		</div>
	);
}
